{
  "checkedInTitle": "您已完成報到",
  "postCheckInInstructions": "報到後須知",
  "appointmentDetails": "預約詳細資料",
  "notifyWarehouse": "我們已通知倉庫您已抵達，以便他們確認可用狀況",
  "waitForStaff": "請等候倉庫人員的進一步指示",
  "unplannedDescription": "您似乎沒有預約。請等候倉庫人員的進一步指示。",
  "whatsappDelay": "第一則 WhatsApp 訊息最多可能需要一分鐘才會送達。",
  "bookNextTitle": "為下次到訪預約",
  "bookNextBody": "註冊 Opendock，以便您下次前來此設施時可以預約",
  "helpFooter": "如需任何協助或其他資訊，請聯絡倉庫人員",
  "finalize": "完成（{seconds}）"
}
